<template>
  <div class="ma-2 ml-3 site_content">
    <comboFarm
      @fromFarm="farmInfo"
    />

    <div class="flex status">
      <div class="control lightgray">현장제어</div>
      <div class="control normal">중앙제어</div>
      <div class="control error">확인필요</div>
      <div class="control noconnect">FC연결안됨</div>
    </div>

    <div v-if="loading" class="loading-monitor-container">
      <div class="spinner"></div>
    </div>

    <div v-else>
      <div class="monitor-container" v-for="(building,b) in building_list" :key="b">
        <div class="text_building flex">
          <div class="line mr-2"></div>
          <div>{{building.building_name}}</div>
        </div>

        <div class="status-control">
          <div v-for="(room,r) in building.room_list" :key="r" class="room-align">
            <div class="room-box" @click="clickRoombox(b,r)" :class="getRoomClass(room)">
              <span :class="getTextClass(room)" class="text_name">{{ room.room_name }}</span>
              <span v-show="room.control_mode > 0" :class="getTextClass(room)">
                {{room.auto_mode}}
              </span>

              <div class="sensor_info">
                <div v-for="info in getSensorInfo(room)" :key="info.type" class="flex mr-2">
                  <img :src="info.icon" 
                  :class="[ {htemp_icon:info.type == 'feel', temp_icon:info.type !== 'feel'} ,getIconColor(room)]" >
                  <div class="text_number" :class="getTextClass(room)">
                    {{ info.value }}
                  </div>
                  <div class="text_number_unit ml-1 mt-1" :class="getTextClass(room)">
                    {{ info.unit }}
                  </div>
                </div>
              </div>

              <div class="vent_info">
                <div>
                  <div v-if="room.now_vent !== null" style="display:flex;">
                    <div class="vent" v-for="(vent,a) in getVentChInfo(room)" :key="a" :class="getControlSet(room)">
                      <img :src="icon_fangreen" class="fan_vent_icon" v-if="vent == 0" :class="getControlIconSet(room)"/>
                      <img :src="icon_fangreen" class="fan_vent_icon test_vent" v-else :class="getControlIconSet(room)" :style="{ '--animation-duration' : (2 - (vent / 100 * 1.9))  + 's' }"/>
                    </div>

                    <div class="flex ml-1" style="font-size:12px;"  :class="getTextClass(room)"> 
                      <div> ( </div>

                      <div v-for="(vent,a) in getVentChInfo(room)" :key="a">
                        <span v-if="vent !== '' " class="ml-1">{{ vent }} </span>
                        <span v-else> - </span>
                        <span>/</span> 
                      </div>

                      <div> ) </div>
                    </div>
                  </div>

                  <div v-else class="flex">
                    <img :src="room.control_mode !== 0 ? icon_fanerror : icon_fanerror_gr" class="vent_icon" >
                    <div class="ml-2"> - </div>
                  </div>
                </div>
              </div>

              <div class="controlinfo" :class="{ lightgray : room.control_mode === 0 }">
                <div class="flex">
                  <div class="mr-2 ml-1">
                    <div class="fc">
                      <img class="fanset_icon" :src="icon_set" />
                    </div>
                  </div>

                  <div>
                    <div class="text_temp color_black"> 목표온도 : {{room.set_temp}} </div>
                    <div class="text_temp color_black"> 온도편차 : {{room.dev_temp}}</div>
                  </div>

                
                  <div>
                    <div class="flex vertical-center ml-3 mt-1">
                      <span :style="[ room.lamp_mac ? { visibility : 'visible' } : { visibility :'hidden'} ]">
                        <v-icon
                          :color="room.lamp_on ? '#DBBA2E' : 'black'"
                          class="light"
                        >
                          mdi-lightbulb-outline
                        </v-icon>
                      </span>
                    </div>
                  </div>
                  
                </div>

                <div class="flex s-bt" style="justify-content: end !important;">
                  <div v-show="room.birthday">
                    <div class="flex mr-1 controldate"> 
                      <img class="icon_pig" :src="icon_pig"/>
              
                      <div class="mt-1">{{room.week_age}}</div>
                      <div class="mt-1"> 주 </div>
                    </div>
                  </div>

                  <div class="controldate mt-1 mb-1">
                    <v-icon size="16">mdi-calendar</v-icon>
                    {{room.setdate && room.setdate.substr(0,10) || ""}}</div>
                  </div>
                </div>  
                <div>
                
                <div v-show="room.setbtn" v-if="$getters.userInfo.grade < 'UT06'">
                  <div v-if="room.mac && room.control_mode > 0" class="flex vertical-center mt-3"> 
                    <button outlined class="setting-btn color_black lightgray mr-5" @click="controlstart(building,room)">
                      제어변경
                    </button>

                    <button outlined class="setting-btn red color_white" @click="controlstop(building,room)">
                      제어중단
                    </button>
                  </div>

                  <div v-else-if="room.mac && room.control_mode === 0" class="flex vertical-center mt-3">
                    <button class="setting-btn color_white green" @click="controlstart(building,room)" >
                      제어시작
                    </button>
                  </div>

                  <div v-else-if="room.mac && room.control_mode === null" class="flex vertical-center mt-3">
                    <button class="setting-btn error" @click="controlstart(item,room)" >
                      제어확인
                    </button>
                  </div>

                  <div v-else>
                  </div>
                </div> 
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="flex vertical-center" v-if="$getters.userInfo.grade < 'UT06'" >
        <v-btn outlined class="allstop_btn rounded-pill elevation-4"
        :loading="loading"
        v-show="setbtn"
        @click="controlallstop()"> 
        제어 전체 중단
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import Apis from '@/api/apis';
import dateUtil from "@/utils/custom/dateProperty.js";

import comboFarm from "@/components/combo/farm.vue";

var setTime = 0;
export default {
  name: 'ControlMonitoring',
  components:{
    comboFarm,
  },
  data() {
    return {
      farmData: { company: {}, farm: {} },

      icon_fan: require("@/assets/barometer/icon_fan.svg"),
      icon_fan_white: require("@/assets/barometer/icon_fan_white.svg"),
      icon_controltemp: require("@/assets/barometer/icon_controltemp.svg"),
      icon_controltemp_white: require("@/assets/barometer/icon_controltemp_white.svg"),
      icon_fancontrol: require("@/assets/control/fan_control.svg"),
      icon_temp: require("@/assets/monitoring/icon/temp_icon.svg"),
      icon_hum: require("@/assets/monitoring/icon/humidity_icon.svg"),
      icon_pig: require("@/assets/control/pig.svg"),
      icon_vent: require("@/assets/control/ventilation.svg"),
      icon_fangreen: require("@/assets/control/fan_control_green.svg"),
      icon_alertfan: require("@/assets/control/alert_fan.svg"),
      icon_alertfan_gray: require("@/assets/control/alert_fan_gray.svg"),
      icon_alertfan_red: require("@/assets/control/alert_fan_red.svg"),
      icon_set: require("@/assets/control/set.svg"),
      icon_fanerror: require("@/assets/control/fan_error.svg"),
      icon_fanerror_gr: require("@/assets/control/fan_error_gr.svg"),

      icon_humantemp: require("@/assets/monitoring/icon/human_temp.svg"),

      
      building_list:[],

      edit_mode: "제어 변경",
      company : {},
      companyItems : [],
      farm: {},
      farmItems: [],
      building: {},
      buildingItems: [],
      loading: false,
      setbtn: false,
      dialog:false,
    }
  },
  destroyed() {
    clearTimeout(setTime);
    // console.log("clearTimeout",setTime);
  },
  async created() {
    Apis.getIpClient((res) => {
      // console.log(res);  
      let client = res
      Apis.pageCount({ //페이지뷰 카운터
        page_name: `${client.city}/${client.country}/${client.region}/${client.loc}/${client.org}/${client.postal}/${client.timezone}`,
        url: this.$route.path,
        ip: client.ip,
        division: "cloud",
      },() => {  // 정상처리
        // console.log("pageCount 호출",res);
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("pageCount 호출 오류",err);
      });
    }).catch( (err) => {  // API 오류 처리
        console.log("getIpClient 호출 오류",err)
    }) 
  },
  methods:{
    farmInfo(data){
      // console.log(data)
      this.farmData = data;
      this.refreshList();
    },
    clickRoombox(b,r){
      // this.building_list[b].room_list[r].setbtn = !this.building_list[b].room_list[r].setbtn;
      this.building_list[b].room_list[r].setbtn = !this.building_list[b].room_list[r].setbtn;
      this.setbtn = this.building_list[b].room_list[r].setbtn
      this.edit_mode = this.setbtn ? "제어 확인" : "제어 변경";
    },
    refreshList(){
      this.$store.commit("resMessage","");
      this.loading = true;

      Apis.listMonitoringControllers({
        farm_cd: this.farmData.farm && this.farmData.farm.code,
        building_cd:"",
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
      } ,(res) => {  // 정상처리
        this.$store.commit("resMessage",res.message);
        
        // console.log(res.data);
        res.data.forEach((building) => {
            building.room_list.forEach((room) => {
              room.setbtn=false;
          })
        })
        this.building_list = res.data;

        this.loading = false;

        // 현재 팬 출력 순차적 세팅
        setTimeout( () =>  this.getNowControllerValue(), 1000);

      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("listMonitoringControllers 호출 오류",err);
        this.loading = false;
      })
    },
    getNowControllerValue() {
      // console.log("갱신");
      this.building_list.forEach(((building) => {
          building.room_list.forEach(((room,index) => {
            setTimeout( async function() {
              // console.log("",element.mac,element.slave_id);
              await Apis.getNowControllerValue({
                mac: room.mac,
                slave_id: room.slave_id,
              } ,(res) => { 
                // console.log("res",res);
                // let res1= "_"
                room.now_vent =  { ch1: res.data.now_vent.substr(0,2).replace("_",0),ch2: res.data.now_vent.substr(3,2).replace("_",0),ch3: res.data.now_vent.substr(6,2).replace("_",0)} ;
                // room.now_vent =  { ch1: res1.substr(0,2).replace("_",0),ch2: res1.substr(3,2).replace("_",0),ch3: res1.substr(6,2).replace("_",0)} ;
                });
              },
              300 * index);
              }),)
            }),);
      // 현재 팬 출력 30초 마다 갱신
      setTime = setTimeout( () =>  this.getNowControllerValue(), 1000 * 60 );

    }, 
    controlallstop(){
      this.$store.commit("resMessage","");
      // alert('개발중')
      if (!confirm("중앙제어 중지 확인! \n 전체 돈방/위치의 제어가 마지막 설정 값 상태의 현장제어로 전환됩니다...\n 전체 돈방/위치의 중앙제어를 중지하겠습니까?")) { return; }
      else {
        this.loading=true;
        let room_list = [];
        this.building_list.forEach((building) => {
          building.room_list.forEach((room) => {
            if (room.control_mode > 0) {
              room_list.push(
                {
                  company_cd: building.company_cd,
                  farm_cd: building.farm_cd,
                  building_cd: building.building_cd, building_name: building.building_name,
                  room_cd: room.room_cd, room_name: room.room_name,
                  setdate: dateUtil.format(new Date(), "yyyy-MM-dd HH:mm:ss"),
                  control_status: 0,
                  control_stand: "",
                  weight_range: 0,
                  daily_range_yn: "",
                  daily_range: 0,
                  birthday: "",
                  history: "일괄 중지",
                })
            }
          })
        });      

        Apis.stopRemoteControl({
          room_list: room_list,
        } ,(res) => {  // 정상처리
          if (res.result) {
            this.loading = false;
            this.refreshList();
            this.$store.commit("resMessage","전체 현장제어로 전환되었습니다");
          } else {
            this.$store.commit("resMessage",res.message);
            this.loading = false;
          }
        }).catch( (err) => {  // 개별 API 오류 처리 예제
          console.log("controlstop 호출 오류",err);
          this.loading = false;
        })
      }
    },
    controlstop(building,room){
      // alert('개발중')
      // console.log(building,room)
      this.$store.commit("resMessage","");
      if (!confirm("제어중지 확인 ! \n" +
                    room.room_name + "의 \n 제어가 마지막 설정 값 상태의 현장제어로 전환됩니다. \n 돈방/위치의 중앙제어를 중지하겠습니까?")) { return; }
      else {
        this.loading = true;

        Apis.stopRemoteControl({
          room_list: [{
                      company_cd: building.company_cd,
                      farm_cd: building.farm_cd,
                      building_cd: building.building_cd, building_name: building.building_name,
                      room_cd: room.room_cd, room_name: room.room_name,
                      setdate: dateUtil.format(new Date(), "yyyy-MM-dd HH:mm:ss"),
                      control_status: 0,
                      control_stand: "",
                      weight_range: 0,
                      daily_range_yn: "",
                      daily_range: 0,
                      birthday: "",
                      history: "단일 중지",
                    }]
        } ,(res) => {  // 정상처리
          if (res.result) {
            // room.control_mode = 0;
            this.refreshList();
            this.loading = false;
            this.$store.commit("resMessage","현장제어로 전환되었습니다");
          } else {
            this.$store.commit("resMessage",res.message);
            this.loading = false;
          }
        }).catch( (err) => {  // 개별 API 오류 처리 예제
          console.log("controlstop 호출 오류",err);
          this.loading = false;
        })
      }
    },
    
    controlstart(building,room){
      // console.log(this.farmData)
      // console.log(building, room);
      // console.log(room.room_name, "room")
      // alert('개발중')
      this.$router.push({
        name: "ControlSetting",
        params: { 
          company: {code:this.farmData.farm.company_cd, name:this.farmData.farm.company_name},
          farm: {code:this.farmData.farm.code, name:this.farmData.farm.name},
          building: {code: building.building_cd, name: building.building_name},
          room: {code: room.room_cd, name: room.room_name + " " + building.farm_name },
          }
      });
    },

    // 스타일링
    getRoomClass(room){
      return {
        white: room.control_mode == 0,
        green: room.control_mode > 0,
        red: room.control_mode === null && room.mac !== null,
        gray: room.mac === null,
      };
    },
    getTextClass(room){
      return{
        color_gold : room.control_mode > 0, 
        color_black: room.control_mode == 0,
        color_white: room.control_mode == null,
        color_error: room.mac !== null && room.control_mode == null
      }
    },
    getControlSet(room){
      return{
        green: room.control_mode == 0,
        white: room.control_mode > 0,
        darkgray:room.control_mode == null,
        red: room.control_mode === null && room.mac !== null,
      }
    },
    getControlIconSet(room){
      return{
        green_color:room.control_mode > 0, 
        white_color: room.control_mode === 0 || room.control_mode == null
      }
    },
    getIconColor(room){
      return{
        white_color:room.control_mode !== 0, 
        green_color: room.control_mode === 0
      }
    },
    getSensorInfo(room){
      return[
        {
          type: 'temp',
          value: room.temp,
          unit: '℃',
          icon: this.icon_temp,
          hoverText: '온도',
        },
        {
          type: 'hum',
          value: room.hum,
          unit: '%',
          icon: this.icon_hum,
          hoverText: '습도',
        },
        {
          type: 'feel',
          value: room.feel,
          unit: '℃',
          icon: this.icon_humantemp,
          hoverText: '체감온도',
        },
      ]
    },
    getVentChInfo(room){
      return[
        room.now_vent.ch1,
        room.now_vent.ch2,
        room.now_vent.ch3
      ]
    },
  }
}
</script>

<style scoped lang="scss">
@import '../../style/base.scss';
.status{
  margin-top:20px;
}
.control{
  padding:3px;
  margin:3px;
  font-size:13px;
  font-weight:600;
  letter-spacing: -1px;
  border:1px solid #d3d3d3;
  width:85px;
  text-align: center;
  border-radius: 5px;
}
.monitor-container{
  margin-top: 10px;
  border:1px solid #D5D5D5;
  border-radius: 5px;
  padding:10px;
}
.text_building{
  font-weight:600;
  font-size:18px;
}
.status-control {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  // justify-content: center; /* 전체를 가운데 정렬 */
}

.room-align {
  display: flex;
  flex: 0 1 auto;
  justify-content: center;
}

.room-box {
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  width:230px;
  margin: 5px;
  padding: 10px;
  border-radius: 7px;
}
.text_name{
  letter-spacing: -2.0px;
  font-size:18px;
  font-weight:600;
}
.text_status{
  font-size: 14px !important;
}
.sensor_info, .vent_info{
  display:flex;
  align-items: center;
  margin-top:10px;
  margin-bottom: 5px;
}
.text_number {
  font-size: 0.9rem;
  letter-spacing: -1px;
  width:28px;
  margin-left:5px;
  text-align: center;
}
.text_number_unit {
  font-size: 10px;
  // margin-left:px;
}
.controlinfo{
  background-color:white;
  border-radius: 5px;
  line-height: 15px;
  padding:5px;
}
.text_temp{
  font-size:14px;
}
.text_birth{
  font-size:13px !important;
  color:#3a4f3f;
  padding-left:6px;
}
.text_birth_unit{
  font-size:15px;
  color:#3a4f3f;
}
.controldate{
  font-size:13px;
}
.setting-btn{
  border-radius: 50px;
  border:0px;
  font-weight: 600 !important;
  padding:10px 20px;
  font-size:15px;
}
.allstop_btn{
  margin-top:10px;
  font-size:18px;
  letter-spacing: -0.75px;
  padding:20px 30px !important;
  border: 1px solid #88191a !important;
  color:#88191a !important;
  font-weight:600;
}
//팬출력
@keyframes rotate_image {
  100% {
    transform: rotate(360deg);
  }
}

.test_vent { animation: rotate_image var(--animation-duration) linear infinite; transform-origin: 50% 50%;}
//아이콘
.fc{
  background-color: #545454;
  width:25px;
  height:25px;
  text-align: center;
  display:flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}
.vent{
  width:20px;
  height:20px;
  margin-right:5px;
  // padding:4px;
  border-radius: 4px;
}
.fan_vent_icon{
  width:15px;
  margin-top:2px;
  margin-left:2px;
}
.fan_icon{
  width:15px;
}
.vent_icon{
  width:22px;
  margin-left:3px;
}
.fanset_icon{
  width:15px;
}
.icon_pig{
  width:25px;
}
.set_icon{
  width:15px;
}
.temp_icon{
  width:11px;
}
.htemp_icon{
  width:22px;
  margin-right:-5px;
}
// 상태
.normal{
  background-color:#3a4f3f !important;
  color:white;
}
.error{
  background-color: #88191a !important;
  color:white;
  border:0;
}
.noconnect{
  background-color: #939393;
  color:white;
}
.white {
  border: 1px solid #545454 !important;
}
.green {
  background-color: #3a4f3f !important;
}
.red {
  background-color: #88191a !important;
}
.gray {
  background-color: #939393 !important;
}
.darkgray{
  background-color: #545454 !important;
}
.gold{
  background-color: #f1f595 !important;
}
.lightgray{
  background-color: #F5F5F5 !important;
}
.color_black {
  color: #3a4f3f !important;
}
.color_gold {
  color: #f1f595 !important;
}
.color_gray {
  color: #868686 !important;
}
.color_error {
  color: #88191a !important;
}
.color_white{
  color:white;
}
.white_color{
  filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%);
}
.green_color{
  filter: invert(28%) sepia(33%) saturate(338%) hue-rotate(82deg) brightness(85%) contrast(87%);
}
.loading-monitor-container{
  border:1px solid #D5D5D5;
  border-radius: 5px;
  height:10vh;
  display:flex;
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 768px) {
.status-control{
  flex-direction: column;
}
.room-box{
  width:280px;
}
}
</style>